<template>
    <b-modal id="group-list-email-modal" centered size="md" v-model="show" no-close-on-backdrop>
        <b-button variant="close-btn" @click="closeModal">
            <i class="fas fa-times"></i>
        </b-button>
        <div class="title-text">
            <h5 class="mb-2">
                <strong>Send Email</strong>
            </h5>
        </div>
        <form @submit.prevent="sendEnrollmentEmail">
            <div class="row">
                <div>
                    <label for="email" class="modal-label-prudential font-bold">
                        Email Address
                    </label>
                    <span class="input-required">*</span><br />
                    <input
                        type="email"
                        v-model="form.email"
                        class="w-100 group-email-input  mb-3"
                        id="email"
                        placeholder="Enter your email address"
                        :class="{ 'group-email-is-invalid': showError('email') }"
                    />
                    <div v-if="showError('email')" class="group-email-error-message">
                        Please enter a valid email address
                    </div>
                </div>
            </div>
            <div class="row justify-content-end payment-download">
                <div class="col-sm-6">
                    <button type="submit" class="univ-btn">Send</button>
                </div>
            </div>
        </form>
    </b-modal>
</template>

<script>
import axios from 'axios';
import { required, email } from "vuelidate/lib/validators";
import { baseApiUrl } from "../../../resource/EndPoints/endpoints";

export default {
    name: "SendGroupEnrollment",
    props: {
        row: {
            required: true,
        },
    },

    data: () => {
        return {
            form: {
                email: "",
            },
            show: false, // Add the 'show' property here
        };
    },
    
    validations: {
        form: {
            email: { required, email },
        },
    },

    watch: {
      'form.email': function () {
          this.$v.form.email.$touch();  // Trigger validation on every change
      }
    },

    methods: {
        sendEnrollmentEmail() {
            this.$v.$touch();  
            if (this.$v.$invalid) {
                return; 
            }
            this.showTable = false;
            let loader = this.$loading.show();
            let url = `${baseApiUrl}api.access/v2/group-census/group-primary-enroll?primaryMemberId=${this.row.id}&groupCensusId=${this.row.group_census_id}&email=${this.form.email}`;
            axios.post(url)
                .then((res) => {
                    this.$notify(res.data.message, "success");
                    this.resetForm();
                    this.$bvModal.hide("group-list-email-modal");
                })
                .catch((err) => {
                    this.$notify(err.response.data.message, "error");
                })
                .finally(() => {
                    loader.hide();
                });
        },

        showError(name) {
            return this.$v.form[name].$error && this.$v.form[name].$dirty;
        },

        closeModal() {
            this.show = false;
            this.$emit("onCloseModal");
            this.resetForm(); 
        },

        resetForm() {
            this.$v.$reset(); 
            this.form.email = ""; 
        },
    }
};
</script>

<style>
.modal-header,
.modal-footer {
    display: none;
}

.modal-content {
    border: 0px;
    border-radius: 10px;
}
.accountInfo-field{
    width: 100%;
    border: 1px solid #dce1e7;
    outline: none;
    border-radius: 6px;
    padding: 9px 15px;
    font-size: 14px;    
    transition: all ease 0.6s;
}
.accountInfo-field:focus{
    border: 1px solid #03C3EC;
    transition: all ease 0.6s;
}
.personalInfo-form label, .businessInfo-form label,
.paymentInfo-form label{
    font-size: 14px;
    margin-bottom: 8px;
    font-weight: 500;
}
.required-indc{
    color: #ff0000;
    font-weight: 500;
}
.btn-close-btn {
    position: absolute;
    top: -15px;
    right: -15px;
    background: #fff;
    color: #000;
    border: 0;
    box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
    border-radius: 60px;
    font-size: 18px;
    width: 45px;
    height: 45px;
    align-items: center;
    justify-content: center;
    display: flex;
}

.group-email-input {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  padding: 0.8rem;
  font-size: 14px;
}

.group-email-error-message {
  color: red;
  font-size: 12px;
  margin-top: -8px;
  margin-bottom: 10px;
}

.group-email-is-invalid {
  border-color: red;
}
</style>